<template>
<div>
<ModalRoot :name="MODAL_KEYS.DEBUGGER_INSPECT">
    <DebuggerInspectModal/>
</ModalRoot>
</div>
</template>

<script>

import ModalRoot from './ModalRoot.vue'
import { MODAL_KEYS } from '../utils/const'
import DebuggerInspectModal from './DebuggerInspectModal.vue'

export default {
    name: 'Modals',
    computed: {
        MODAL_KEYS () {
            return MODAL_KEYS
        }
    },
    components: { DebuggerInspectModal, ModalRoot }
}
</script>

<style scoped>

</style>
